import Button from '@app-studio-web/ui/components/Button'
import Layout from '@app-studio-web/ui/components/Layout'
import { Trans, useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'

export default function UnsurePage() {
  const { t } = useTranslation()

  return (
    <Layout>
      <div className="flex h-full flex-col">
        <div className="flex grow flex-col items-center justify-center text-center">
          <span className="mb-6 text-[100px]">💡</span>
          <h1 className="custom-heading mb-6 text-3xl">
            {t('pages.onboarding.unsure.lowRecall.heading')}
          </h1>
          <p className="mb-4 text-base">
            <Trans
              components={{
                bold: <span className="font-bold" />,
              }}
              i18nKey="pages.onboarding.unsure.lowRecall.text"
            />
          </p>
          <div className="bg-custom-yellow max-w-[500px] rounded-[20px] px-6 py-5">
            <p className="text-left text-base">
              {t('pages.onboarding.unsure.lowRecall.encouragement')}
            </p>
          </div>
        </div>

        <Form className="mb-8 shrink-0" method="post">
          <div className="flex justify-center">
            <Button
              title={t('pages.onboarding.unsure.cool')}
              type="submit"
              dataTestId="button-continue"
            />
          </div>
        </Form>
      </div>
    </Layout>
  )
}
